// Locales without their own spond.com legal pages get the English ones.
export const LEGAL_LINK_HREFS_BY_LOCALE = {
  default: {
    terms: "https://www.spond.com/spond-terms/",
    cookies: "https://www.spond.com/cookie-policy/",
    privacy: "https://www.spond.com/privacy/",
    sitemap: "https://www.spond.com/sitemap/",
  },
  nb: {
    terms: "https://www.spond.com/no/spond-vilkar/",
    cookies: "https://www.spond.com/no/informasjonskapsler-2/",
    privacy: "https://www.spond.com/no/personvernserklaering/",
    sitemap: "https://www.spond.com/no/sitemap-no/",
  },
  de: {
    terms: "https://www.spond.com/de/spond-bedingungen/",
    cookies: "https://www.spond.com/de/cookie-richtlinien/",
    privacy: "https://www.spond.com/de/datenschutz-bestimmungenv/",
    sitemap: "https://www.spond.com/de/seitenverzeichnis/",
  },
  fr: {
    terms: "https://www.spond.com/fr/conditions-spond/",
    cookies: "https://www.spond.com/fr/politique-de-cookies/",
    privacy: "https://www.spond.com/fr/confidentialite/",
    sitemap: "https://www.spond.com/fr/plan-du-site/",
  },
} as const;

type LegalLinksLocale = keyof typeof LEGAL_LINK_HREFS_BY_LOCALE;

export function getLegalLinks(locale: string) {
  const language = locale.toLowerCase().slice(0, 2);
  return LEGAL_LINK_HREFS_BY_LOCALE[
    language in LEGAL_LINK_HREFS_BY_LOCALE
      ? (language as LegalLinksLocale)
      : "default"
  ];
}
